<template>
    <div>
        <v-menu v-model="openMenu"
            offset-y
            :close-on-content-click="false"
        >
            <template v-slot:activator="{ on }">
                <span class="fe-color-selector-card" v-on="on" 
                    :style="{'border': openMenu && !noBorder ? '1px solid #2B87FF' : !openMenu && !noBorder ? '1px solid #7E8494' : '0px',
                        'padding': noBorder ? '5px' : '0px'
                    }">
                    <v-btn
                        text icon dark
                        :color="selection"
                        style="margin: 0;"
                        :aria-label="'Color Menu '+dataTest"
                        :data-test="'color-picker-menu-btn-'+dataTest"
                    >
                        <v-icon class="square" :style="{'background': selection}"></v-icon>
                    </v-btn>
                    <v-icon class="ml-1" :style="{'padding-top': noBorder ? '8px' : '0px'}">fa-caret-down</v-icon>
                </span>
            </template>
            <v-color-picker v-model="selection" mode="hexa" hide-mode-switch />
        </v-menu>
    </div>
</template>

<script>
    export default {
        name: 'ColorPicker',

        props: {
            value: {
                type: String,
                default: null
            },
            noBorder: {
                type: Boolean,
                default: false
            },
            dataTest: {
                type: String,
                default: null
            },
        },

        watch: {
            value(v) {
                this.selection = v
            },
            selection(v) {
                if (v === this.value) return
                this.$emit('update', v)
                this.$emit('input', v)
            }
        },

        data() {
            return {
                selection: this.value,
                openMenu: false,
            }
        }
    }
</script>

<style scoped lang="scss">
    .fe-color-selector-card {
        height: 36px;
        width: 64px;
        border-radius: 3px;
        display: flex;
    }
    .square {
        height: 24px;
        width: 24px;
        border-radius: 2px;
    }
</style>